import leftsidebarpopulate from '/src/lib/custom/js/leftsidebarpopulate.js';

const createUpdateFilesEvents = (() => {
    const storageKey = 'browse_files';

    // Helper function to get data from localStorage
    function getData() {
        const data = localStorage.getItem(storageKey);
        return data ? JSON.parse(data) : [];
    }

    // Helper function to save data to localStorage, sorted by lastUpdated
    function saveData(data) {
        data.sort((a, b) => new Date(b.lastUpdated) - new Date(a.lastUpdated));
        localStorage.setItem(storageKey, JSON.stringify(data));
    }

    // Add a new file
    function addFile(newFile) {
        console.log("Addinging new file data: ", newFile);
        const data = getData();

        if (data.some(file => file.fileName === newFile.fileName)) {
            console.error(`File with fileName "${newFile.fileName}" already exists.`);
            return false;
        }

        data.push(newFile);
        saveData(data);
        leftsidebarpopulate.init();
        return true;
    }

    // Update an existing file, including the fileName if needed
    async function updateFile(originalFileName, updatedFile) {
        const data = getData();
        const fileIndex = data.findIndex(file => file.fileName === originalFileName);

        if (fileIndex === -1) {
            console.error(`File with fileName "${originalFileName}" not found.`);
            return false;
        }

        // Check for duplicate fileName if updating fileName
        if (updatedFile.fileName && updatedFile.fileName !== originalFileName) {
            if (data.some(file => file.fileName === updatedFile.fileName)) {
                console.error(`File with fileName "${updatedFile.fileName}" already exists.`);
                return false;
            }
        }

        data[fileIndex] = { ...data[fileIndex], ...updatedFile };
        saveData(data);
        leftsidebarpopulate.init();
        return true;
    }

    // Copy an existing file with new attributes
    function saveAsFile(originalFileName, updatedFile) {
        const data = getData();
        const originalFile = data.find(file => file.fileName === originalFileName);

        if (!originalFile) {
            console.error(`Original file with fileName "${originalFileName}" not found.`);
            return false;
        }

        // Ensure the new fileName is provided and does not already exist
        if (!updatedFile.fileName) {
            console.error("No new fileName provided for the copy.");
            return false;
        }

        if (data.some(file => file.fileName === updatedFile.fileName)) {
            console.error(`File with fileName "${updatedFile.fileName}" already exists.`);
            return false;
        }

        // Create a new file by copying attributes from the original file and merging with updated values
        const newFile = {
            ...originalFile,
            ...updatedFile
        };

        data.push(newFile);
        saveData(data);
        leftsidebarpopulate.init();
        console.log(`File copied from "${originalFileName}" to "${updatedFile.fileName}".`);
        return true;
    }


    // Delete a file by fileName
    function deleteFile(fileName) {
        const data = getData();
        const updatedData = data.filter(file => file.fileName !== fileName);

        if (updatedData.length === data.length) {
            console.error(`File with fileName "${fileName}" not found.`);
            return false;
        }

        saveData(updatedData);

        leftsidebarpopulate.init();
        return true;
    }

    function searchInflatedDescription(description, locale, type) {
        const data = getData();

        // Null check and length check
        if (!data || data.length === 0) {
            console.log("Data is null or empty.");
            return null;
        }

        let matchingFile = null;

        data.forEach(file => {
            if (
                file.inflatedDescription === description &&
                file.locale === locale &&
                file.type === type
            ) {
                matchingFile = file;
                console.log("Match found");
            }
        });

        if (!matchingFile) {
            console.log("No matching file found.");
        }

        return matchingFile ? matchingFile.filePath : null;
    }




    return {
        getData,
        saveData,
        addFile,
        updateFile,
        saveAsFile,
        deleteFile,
        searchInflatedDescription
    };
})();

export default createUpdateFilesEvents;




// // Adding a file
// createUpdateFilesEvents.addFile({
//     message: "File retrieved successfully",
//     fileName: "resume-New",
//     filePath: "/resume/usertemplates/direct/aef45cce-980c-4e9d-8814-7bf1162cb9f7/resume-New.html",
//     lastUpdated: "2024-11-10T04:01:00Z",
//     size: "8017",
//     shortDescription: "This is a short description",
//     inflatedDescription: "Sample description text."
// });

// // Updating a file (including changing fileName and shortDescription)
// createUpdateFilesEvents.updateFile("resume-New", {
//     fileName: "resume-Updated",
//     lastUpdated: "2024-11-10T05:00:00Z",
//     shortDescription: "Updated short description",
//     inflatedDescription: "Updated description text."
// });

// // Deleting a file
// createUpdateFilesEvents.deleteFile("resume-Updated");

